<template>
    <div v-if="userPower">
        <slot v-if="userPower.permissionList.indexOf(p) > -1"></slot>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    props: ["p"],
    computed: {
        ...mapGetters(["userPower"]),
    }
};
</script>